const textareaInputWrapper = 'textarea-input-wrapper';
const textareaDisplayWrapper = 'textarea-display-wrapper';

/**
 * @param {{
 *    name: string,
 *    label: string,
 *    value: string,
 *    onChange: Function,
 * }} param 
 * @returns {React.JSX.Element}
 */
export const TextAreaWrapper = (param) => {
  const {
    name,
    label,
    value,
    onChange: handleChange = () => {}
  } = param;

  return (
    <>
      <div className={`flex flex-column gap-8 ${textareaInputWrapper}`}>
        <label className='input-label'>{label}</label>
        <textarea
          name={name}
          className='flex flex-fill border-light-grey-1 min-height-64 p-2 font-roboto font-14 color-dark-grey border-box resize-none'
          wrap='hard'
          value={value}
          onChange={handleChange}
        />
      </div>

      <div className={`flex flex-column gap-8 ${textareaDisplayWrapper} d-none`}>
        <label className='input-label'>{label}</label>
        <p className='font-roboto font-light line-20 font-14 m-0'>{value}</p>
      </div>
    </>
  );
};

export default TextAreaWrapper;
